<template>
    <auto-row class="wrap" mode="column">
        <auto-col>
            <head-nav @change="navChange"></head-nav>
        </auto-col>
        <auto-col class="page-top">
            <div class="banner-box" ref="eLocation">
                <img src="@/assets/image/scheme/04/00 banner.png" class="max-size" data-fit-cover alt=""  />
            </div>
        </auto-col>
        <auto-col style="background-color:#fff; border-bottom:1px solid #C7C7C7;">
            <location class="content-w" :data="currentNav.pathArr || []"></location>
        </auto-col>
        <auto-col  class="page-content" size="auto">
            <div class="f-a-j-j page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="f-a-j-j-content">
                            <div class="title">
                                <span>{{z_g_l_l_h_j_s_form.title_1}}</span>
                                <span>{{z_g_l_l_h_j_s_form.title_2}}</span>
                            </div>
                            <p class="text">{{z_g_l_l_h_j_s_form.content_1}}</p>
                            <p class="text">{{z_g_l_l_h_j_s_form.content_2}}</p>
                            <p class="text">{{z_g_l_l_h_j_s_form.content_3}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="s-q-y-l-g-l page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="s-q-y-l-g-l-content">
                            <div class="title">
                                <span>养老院管理</span>
                                <span>为什么这么难？</span>
                            </div>
                            <auto-row class="max-size list flew-row-wrap">
                                <auto-col class="list-item" v-for="(item,index) of s_q_y_l_g_l_list" :key="index">
                                    <div class="cell">
                                        <p class="text">{{item.content}}</p>
                                        <img class="cell-dh" src="@/assets/image/scheme/04/dh.png" width="31" alt="">
                                    </div>
                                </auto-col>
                            </auto-row>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-content-child"
                v-for="(src,i) of imgArr"
                :key="i"
            >
                <div class="content-w">
                    <img :src="src" width="100%" alt="" />
                </div>
            </div>
        </auto-col>
        <auto-col>
            <form-box></form-box>
            <footer-box></footer-box>
            <fixed-box></fixed-box>
        </auto-col>
    </auto-row>
</template>

<script>
    import {
        autoRow,
        autoCol
    } from "@/components"
    import headNav from "@/components/headNav"
    import formBox from "@/components/formBox"
    import footerBox from "@/components/footerBox"
    import fixedBox from "@/components/fixedBox"
    import location from "@/components/location"
    import {
        methods
    } from "@/mixins"
    export default {
        name: '',
        components: {
            autoRow,
            autoCol,
            headNav,
            formBox,
            footerBox,
            fixedBox,
            location,
        },
        mixins:[methods],
        props: [],
        data() {
            return {
                currentNav:{},
                imgArr:[
                    // require('@/assets/image/scheme/04/pic-01.png'),
                    // require('@/assets/image/scheme/04/pic-02.png'),
                    require('@/assets/image/scheme/04/pic-03.png'),
                    require('@/assets/image/scheme/04/pic-04.png'),
                ],
                z_g_l_l_h_j_s_form:{ //中国老龄化加深
                    title_1:'中国老龄化',
                    title_2:'加深',
                    content_1:'我们在物联网、人工智能、云计算、先进照护器具与养老院场景深度结合方面，养老团队积累了丰富的案例和经验。',
                    content_2:'我们致力于为各大养老机构提供全天候运转的智慧化支撑体系。通过软硬件与人员的互联互动，达到降低风险、提升运营管理效率、优化服务质量、扩大服务半径的目的。',
                    content_3:'方案适用于：机构养老、地产养老、医养结合、养老院、敬老院、养老福利院、老年公寓、老年康复中心、酒店式养老公寓等。'
                },
                s_q_y_l_g_l_list:[
                    {content:'机构如何降低成本运营决策缺乏数据支撑，投入与需求匹配不当造成成本浪费。'},
                    {content:'如何提高运营效率机构信息化水平较低，传统的管理方式难以满足专业化服务需求。'},
                    {content:'服务流程如何规范服务流程混乱不统一，如何进行规范化管理及日常监督。'},
                    {content:'服务管理监督困难护理计划传达不清、服务情况难以留存和记录，监督工作难以开展。'},
                    {content:'潜在风险难以预警如何实现对老人进行24小时监护、意外事故的预警和及时处理。'},
                    {content:'老人子女如何安心老人在家的生活、护理以及突发情况，如何实时让子女。'}
                ],
                // type: this.$route.params.pathMatch.replace("/",''),
            }
        },
        computed: { //计算属性

        },
        watch: {  //监听器

        },
        methods: {
            navChange(nav){
                this.currentNav = nav;
            }
        },
        created(){

        }, //组件实例创建完成，属性已绑定，但DOM还未生成，属性还不存在
        mounted(){
            this.$refs.eLocation && this.toScrollTop(this.$refs.eLocation.offsetTop);
        }, //模板编译/挂载之后(不保证组件已在document中)
        beforeRouteLeave(to, from, next) {
            next();
        },
//        beforeCreate(){}, //组件实例刚被创建，组件属性计算之前，如data属性等
//        beforeMount(){}, //模板编译/挂载之前
//        beforeUpdate(){}, //组件更新之前
//        updated(){}, //组件更新之后
//        activated(){}, //for keep-alive,组件被激活时调用
//        deactivated(){}, //for keep-alive,组件被激活时调用
//        beforeDestory(){}, //组件销毁前调用
//        destoryed(){}, //组件销毁后调用
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .wrap{
        background-color:#f0f2f5;
        min-height:100vh;
    }
    .banner-box{
        position:relative;
    }
    .banner-box img{
        width:100%;
        max-height:600px;
        min-height:200px;
        overflow:hidden;
        vertical-align: middle;
    }
    .page-content{
        position: relative;
        z-index:2;
    }
    .page-content-child:nth-child(2n+1){
        background-color:#ffffff;
    }
    .page-content-child:nth-child(2n+2){
        background-color: #F9F9F9;
    }

    .page-content-child .title span:nth-child(1){
        color:#333333;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }
    .page-content-child .title span:nth-child(2){
        color:#2FA8D0;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }

    .page-content-box{
        overflow:hidden;
    }


    .f-a-j-j .f-a-j-j-content{
        text-align: center;
        padding:150px 0 200px 0;
    }


    .f-a-j-j .text{
        color:#333333;
        font-size: 24px;
        padding:30px 140px 0 140px;
        line-height: 1.6;
        text-align: left;
        transition: all .3s;
    }

    .f-a-j-j .text:nth-of-type(1){
        padding-top:60px;
    }

    .f-a-j-j .text:hover{
        transform: translateY(-5px);
    }

    .s-q-y-l-g-l .s-q-y-l-g-l-content{
        text-align: center;
        padding:128px 0 100px 0;
    }


    .s-q-y-l-g-l .list{
        width:calc(100% + 40px);
        text-align: center;
        margin-left: -20px;
        padding:0 5px;
    }

    .s-q-y-l-g-l .list-item{
        width:calc(33.33% - 40px);
        margin: 0 20px;
        margin-top:80px;
        text-align: center;
        transition: all .3s;
        /*height: 20vw;*/
        max-height: 160px;
        box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.1);
    }

    .s-q-y-l-g-l .list-item .cell{
        padding:30px 38px;
        text-align: left;
        position: relative;
    }

    .s-q-y-l-g-l .list-item .cell .cell-dh{
        position: absolute;
        top:-10px;
        left: 10px;
    }



    .s-q-y-l-g-l .list-item .cell .text{
        line-height: 1.6;
        font-size: 18px;
        color:#333333;
        position: relative;
    }

    .s-q-y-l-g-l .list-item:hover{
        transform: translateY(-5px);
        box-shadow: 0px 8px 11px 0px rgba(65,61,61,0.23);
    }



    .w-m-d-y-s .w-m-d-y-s-content{
        text-align: center;
        padding:100px 0 150px 0;
        margin:0 60px;
    }

    .w-m-d-y-s .list{
        width:calc(100% + 100px);
        text-align: left;
        margin-left: -50px;
    }

    .w-m-d-y-s .list-item{
        width:calc(50% - 100px);
        margin: 0 50px;
        margin-top:120px;
        text-align: left;
        transition: all .3s;
    }

    .w-m-d-y-s .list-item:hover{
        transform: translateY(-5px);
    }

    .w-m-d-y-s .list-item .cell{
        text-align: left;
    }

    .w-m-d-y-s .list-item .cell .title{
        font-size: 24px;
        color: #333333;
        padding-top:15px;
    }

    .w-m-d-y-s .list-item .cell .text{
        line-height: 1.6;
        padding-top:15px;
        font-size: 18px;
    }


    /*适配不同尺寸*/
    @media screen and (max-width: 1540px){


    }

    @media screen and (max-width: 1200px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:130px 0 180px 0;
        }

        .f-a-j-j .text{
            padding:30px 100px 0 100px;
        }

        .s-q-y-l-g-l .s-q-y-l-g-l-content{
            text-align: center;
            padding:100px 0 80px 0;
        }

        .s-q-y-l-g-l .list{;
            padding:0 100px;
        }

        .s-q-y-l-g-l .list-item{
            width:calc(50% - 40px);
            margin: 0 20px;
            margin-top:70px;
            text-align: center;
            transition: all .3s;
            height: auto;
            max-height: 160px;
            box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.1);
        }

        .w-m-d-y-s .w-m-d-y-s-content{
            padding:80px 0 130px 0;
        }

    }

    @media screen and (max-width: 960px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:110px 0 160px 0;
        }

        .f-a-j-j .text{
            padding:30px 60px 0 60px;
        }


        .s-q-y-l-g-l .s-q-y-l-g-l-content{
            text-align: center;
            padding:80px 0 60px 0;
        }

        .s-q-y-l-g-l .list{;
            padding:0 60px;
        }

        .s-q-y-l-g-l .list-item{
            width:calc(50% - 40px);
            margin: 0 20px;
            margin-top:60px;
            text-align: center;
            transition: all .3s;
            height: auto;
            max-height: 160px;
            box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.1);
        }

        .w-m-d-y-s .w-m-d-y-s-content{
            padding:60px 0 110px 0;
        }
    }

    @media screen and (max-width: 760px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:90px 0 140px 0;
        }

        .f-a-j-j .text{
            padding:30px 10px 0 10px;
        }

        .s-q-y-l-g-l .s-q-y-l-g-l-content{
            text-align: center;
            padding:60px 0 40px 0;
        }

        .s-q-y-l-g-l .list{;
            padding:0 5px;
        }

        .s-q-y-l-g-l .list-item{
            width:calc(50% - 40px);
            margin: 0 20px;
            margin-top:50px;
            text-align: center;
            transition: all .3s;
            height: auto;
            max-height: 100vh;
            box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.1);
        }

        .w-m-d-y-s .w-m-d-y-s-content{
            padding:40px 0 90px 0;
        }
    }
</style>
